import { Size } from '../constants';

export type ToggleSize = Size.SMALL | Size.MEDIUM | Size.LARGE;

export enum ToggleState {
  ACTIVE = 'ACTIVE',
  OFF = 'OFF'
}

export function isToggleSize(value: unknown): value is ToggleSize {
  return (
    typeof value === 'string' &&
    (value === Size.SMALL || value === Size.MEDIUM || value === Size.LARGE)
  );
}
